import { createAsyncReducer, createReducerFromMap, createDefaultInitialState } from "@coverme/redux";

export const initialState = createDefaultInitialState({});

export function getPatientFindings(state, action) {
    return {
        ...state,
        data: action.value.data,
    };
}

export const patientFindingsReducer = createReducerFromMap(initialState, {
    ...createAsyncReducer("GET_PATIENT_FINDINGS", getPatientFindings),
});
